import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '@/i18n/src/locales';
import TitlePage from '@/components/TitlePage';
import Card from '@/components/Card';
import DataTable from '@/components/DataTable';
import Badge from '@/components/Badge';
import ContentLoader from 'react-content-loader';
import IcEdit from '@/assets/images/ic-edit.svg';
import * as ROUTES from '@/routes/routes';
import { fetchProgressiveDiscounts } from '@/store/actions/progressiveDiscount';

function formatDate(dateStr) {
  if (!dateStr) return '-';
  const rawDate = String(dateStr).includes('T') ? String(dateStr).split('T')[0] : String(dateStr).split(' ')[0];
  if (rawDate.includes('-')) {
    const parts = rawDate.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }
  const dateObj = new Date(dateStr);
  if (isNaN(dateObj.getTime())) return '-';
  return dateObj.toLocaleDateString('pt-BR');
}

function ProgressiveDiscounts() {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.progressiveDiscount?.discounts) || [];
  const isLoading = useSelector((state) => state.progressiveDiscount?.discountIsLoading);

  useEffect(() => {
    dispatch(fetchProgressiveDiscounts());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Administração Franqueadora - {translate('progressiveDiscount')}</title>
      </Helmet>
      <TitlePage
        title={translate('progressiveDiscount')}
        link={ROUTES.PROGRESSIVE_DISCOUNT_CREATE}
        txtButton={translate('progressiveDiscountCreate')}
      />
      <Card>
        {isLoading ? (
          <ContentLoader width="100%" speed={1} height="200px" backgroundColor="#c6c6c6" foregroundColor="#F0F0F5">
            <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="60" rx="5px" ry="5px" width="100%" height="30px" />
            <rect x="0" y="100" rx="5px" ry="5px" width="100%" height="30px" />
            <rect x="0" y="140" rx="5px" ry="5px" width="100%" height="30px" />
          </ContentLoader>
        ) : (
          <DataTable
            data={items}
            searchPlaceHolder={translate('searchProgressiveDiscount') || 'Buscar desconto'}
            columns={[
              {
                name: translate('name') || 'Nome',
                selector: 'Nome',
                sortable: true,
              },
              {
                name: translate('progressiveDiscountType') || translate('type') || 'Tipo',
                selector: 'DescricaoDescontoProgressivoTipo',
                sortable: true,
                cell: (row) => row.DescricaoDescontoProgressivoTipo || row.descricaoDescontoProgressivoTipo || '-',
              },
              {
                name: translate('createdDate') || 'Data de Cadastro',
                selector: 'DataCadastro',
                sortable: true,
                cell: (row) => {
                  const d = row.DataCadastro || row.dataCadastro || row.DataCriacao || row.dataCriacao || row.Data || row.data;
                  return formatDate(d);
                },
              },
              {
                name: translate('Ativo') || 'Ativo',
                selector: 'Ativo',
                compact: true,
                width: '120px',
                center: true,
                cell: (row) => {
                  return row.Ativo ? (
                    <Badge type="success">{translate('Ativo') || 'Ativo'}</Badge>
                  ) : (
                    <Badge type="danger">{translate('Inativo') || 'Inativo'}</Badge>
                  );
                },
              },
              {
                width: '80px',
                center: true,
                cell: (row) => (
                  <Link to={`${ROUTES.PROGRESSIVE_DISCOUNT_CREATE}/${row.IdDescontoProgressivo}`}>
                    <img className="icon-edit" src={IcEdit} alt={row.Nome} />
                  </Link>
                ),
              },
            ]}
            columnFilter={['Nome', 'DescricaoDescontoProgressivoTipo', 'DataCadastro']}
            isLoading={isLoading}
          />
        )}
      </Card>
    </>
  );
}

export default ProgressiveDiscounts;
